// extracted by mini-css-extract-plugin
export default {"element":"FormScript-module--element--d08a7","heading":"FormScript-module--heading--fadb5","raw":"FormScript-module--raw--fc400"};